define(function(require, exports, module) {
    const languageUtil = require('util/language.util');
    const deviceUtil = require('util/device.util');
    const server = require('server');
    const config = require('config');
    const _ = require('underscore');
    const Class = require('Class');
    const user = require('user');
    const $ = require('j');

    module.exports = Class.create({
        terms: {},

        fetch: function(options) {
            const deferred = $.Deferred();
            const userLang = user.get('lang');
            const language = languageUtil.convertToIMS(userLang);
            const filteredOptions = _.omit(options, 'ID', 'responses');

            if (this.terms[userLang]) {
                deferred.resolve(this.terms[userLang]);
            } else {
                server.send(_.extend({
                    ID: 35595,
                    responses: [35596, 35597],
                    description: 'Get Terms And Conditions File',
                    language: language && language.toUpperCase() || '',
                    clientType: config.get('clientType'),
                    clientPlatform: deviceUtil.clientPlatform,
                    contentType: 'html',
                    casinoName: config.get('casinoName'),
                    stringFormat: true,
                    skin: config.get('clientSkin')
                }, filteredOptions))
                    .done(function(response) {
                        deferred.resolve(this.save(response));
                    }.bind(this))
                    .fail(function() {
                        deferred.resolve(null);
                    });
            }

            return deferred;
        },

        save: function(response) {
            return this.terms[user.get('lang')] = this.parse(response.data);
        },

        parse: function(data) {
            const file = data.file || data.base64file;
            const content = Array.isArray(file)
                ? String.fromCharCode.apply(null, file)
                : decodeURIComponent(atob(file).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

            return {
                content: content,
                version: data.tcVersion
            };
        }
    });
});
